<template>
  <v-container fluid class="reimbursement-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            v-if="initvalue.reimbursementstatus!=='Complete'" 
            :href="`#tab-reimbursement`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document-multiple</v-icon>
            Reimbursement
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-files`">
            <v-icon class="mr-3">mdi-file-multiple</v-icon>
            Files
          </v-tab>
          <v-tab-item
            v-if="initvalue.reimbursementstatus!=='Complete'" 
            :value="'tab-reimbursement'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Edit Reimbursement</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'reimbursementnum')"
                        v-bind:value="initvalue.reimbursementnum"
                        placeholder="Reimbursement Num"
                        persistent-hint
                        single-line hint="Enter the reimbursement num">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="reimbursementstatus"
                        :value="initvalue.reimbursementstatus"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'reimbursementstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the reimbursement status">
                      </v-select>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/reimbursement/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editReimbursement()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <FileEditView :id="initvalue._id" :route="`reimbursement`" :files="files" />
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import FileEditView from "@/pages/File/Components/FileEditView.vue";

export default {
  components: {
    FileEditView
  },
  data () {
    return {
      reimbursement: {},
      reimbursementstatus: ['New', 'Pending', 'Complete'],
      files: [],
      initvalue: {},
    }
  },
  methods: {
    ...mapActions('Reimbursement', ['updateReimbursementRequest','getReimbursementsRequest']),
    async editReimbursement() {
      this.reimbursement._id = this.initvalue._id;
      this.updateReimbursementRequest(this.reimbursement);
      router.push('/reimbursement/list');
    },
    updateChangedValue(value, field){
      this.reimbursement[field] = value;
    },
  },
  computed: {
    ...mapState('Reimbursement', ['isReceiving'])
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'ReimbursementList' });
    this.files = this.initvalue.files;
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
